module.exports = __webpack_public_path__ + "img/Group 606.bc9fe2d2.png";